import firebase from '../config/firebase-config';

export const googleProvider = new firebase.auth.GoogleAuthProvider();